import { Component, OnInit, Input, Renderer2, Inject, EventEmitter, Output } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TopbarService } from '../../services/topbar.service';
import { AuthService } from '../../../auth/services/auth.service';
import { ApplicationUser } from '../../../auth/models/application-user.model';
import { Notification } from '../../models/notification';
import { NotificationsService } from '../../services/notifications.service';
import { Observable } from 'rxjs';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
})
export class TopbarComponent implements OnInit {
  @Input() loading = false;
  @Input() notifications: Notification[];

  @Output() NotificationClicked = new EventEmitter<Notification>();
  titleLogo;
  menuActive = false;
  user: ApplicationUser;
  profileActive = false;

  $messagingToken: Observable<string>;

  message;

  get unreadCount() {
    if (!this.notifications) {
      return 0;
    }
    return this.notifications.filter(a => !a.IsRead).length;
  }

  constructor(
    @Inject(DOCUMENT) private document,
    private renderer: Renderer2,
    private authService: AuthService,
    private topbarService: TopbarService,
    private notificationService: NotificationsService,
    private afm: AngularFireMessaging,
    public platform: Platform
  ) {
    this.$messagingToken = notificationService.$token;
    this.topbarService.$subtitle.subscribe(a => (this.titleLogo = a));
  }

  ngOnInit() {
    this.authService.getAuth().subscribe(u => (this.user = u));
  }

  toggle() {
    this.menuActive = !this.menuActive;
    this.updateRoot();
  }

  updateRoot() {
    this.menuActive
      ? this.renderer.addClass(this.document.body, 'main-nav--active')
      : this.renderer.removeClass(this.document.body, 'main-nav--active');
  }

  askPermission($event) {
    if ($event.checked) {
      this.notificationService.requestPermission();
      this.notificationService.receiveMessage();
      this.message = this.notificationService.currentMessage;
    } else {
      this.notificationService.removePermission();
    }

    // console.log($event.checked);
  }

  // removePermission() {
  //   this.notificationService.removePermission();
  // }
}
